$(document).ready(function () {	

	initBooking();
});

function initBooking() {
	if( $('body.group.home').length > 0 ) {

		if ( !$('body').hasClass('booking-init') ) {
			$('body').addClass('booking-init');
			if( $(window).outerWidth() >= 640  ) {
				$('.booking__inner').prepend('<div class="datepicker__overlay"></div>');
			} else {
				$('.booking-mobile').prepend('<div class="datepicker__overlay"></div>');
			}
			
			var script = document.createElement('script');
			script.onload = function () {
				openBooking();
			};
			script.src = '/assets/vendor/litepicker.js';
			
			document.head.appendChild(script);
		} else {
			openBooking();
		}
	}
}

function openBooking() {

	if( $(window).outerWidth() >= 640  ) {

		$('.booking__field-adults button').on('click', function() {
			$('.booking__field-adults .booking__quantity--adults').addClass('open');
			
			$('.booking__field-adults').on('mouseleave', function() {
				$('.booking__field-adults .booking__quantity--adults').removeClass('open');
			})
		})

		$('.booking__field-child button').on('click', function() {
			$('.booking__field-child .booking__quantity--child').toggleClass('open');

			$('.booking__field-child').on('mouseleave', function() {
				$('.booking__field-child .booking__quantity--child').removeClass('open');
			})
		})

		$('.booking__field-location-open').on('click', function() {
			$('.booking__field-location').toggleClass('open');
		})

		$('.booking__field-location a').on('click', function() {
			var hotelInput = $('input[name="hotel"]');
			var hotelID = $(this).data('hotel');
			hotelInput.val(hotelID);
			$('.selected-hotel').removeClass('selected-hotel')
			$(this).addClass('selected-hotel');
			$('.booking__field-location-open').text( $(this).find('h4').text() );
			$('.booking__field-location').removeClass('open');
			return false;
		})
		
		$('.booking form').on('submit', function () {
			if ( $('input[name="hotel"]').val() === '' ) {
				alert('Please choose a property.');
				return false;
			}
		});
		
		$('.booking__quantity-up').on('click', function (e) {
			e.preventDefault();
			
			var $field = $(this).prev();
			var fieldValue = $field.val();
			
			if ( fieldValue < $field.attr('max') ) {
				fieldValue++;
				$field.val(fieldValue);
			}
		});
		
		$('.booking__quantity-down').on('click', function (e) {
			e.preventDefault();
			
			var $field = $(this).next();
			var fieldValue = $field.val();
			
			if ( fieldValue > $field.attr('min') ) {
				fieldValue--;
				$field.val(fieldValue);
			}
		});
		
		var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
		var dayNames   = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
		
		//var datepicker = new Datepickk();
		var today = new Date();
		var tomorrow = new Date();
			tomorrow.setDate(today.getDate() + 1);
		var yesterday = new Date();
			yesterday.setDate(today.getDate() - 1);
		
		var datepicker = new Litepicker({ 
			element: document.getElementById('datepicker'),
			parentEl: $('.booking__overlay')[0],
			minDate: yesterday,
			numberOfMonths: 2,
			numberOfColumns: 2,
			minDays: 2,
			singleMode: false,
			startDate: today,
			endDate: tomorrow,
			showTooltip: false
		});
		
		datepicker.on('hide', function () {
			updateDates();
			$('.booking__overlay').fadeOut();
		});
			
		updateDates();

		$('.booking__field--check-in, .booking__field--check-out').on('click', function () {

			$('.booking__overlay').fadeIn();
			datepicker.show();
		});
		
		function updateDates() {
			var checkInDate = new Date( datepicker.getStartDate().dateInstance );
			var checkOutDate = new Date( datepicker.getEndDate().dateInstance );
			
			$('input[name="arrive"]').val( pad(checkInDate.getDate(), 2) + '-' +  pad(checkInDate.getMonth()+1*1, 2) + '-' + checkInDate.getFullYear() );
			
			$('input[name="depart"]').val( pad(checkOutDate.getDate(), 2) + '-' +  pad(checkOutDate.getMonth()+1*1, 2) + '-' + checkOutDate.getFullYear() );
		}



	} else {
		
		$('.booking-mobile__quantity-up').on('click', function (e) {
			e.preventDefault();
			
			var $field = $(this).prev();
			var fieldValue = $field.val();
			
			if ( fieldValue < $field.attr('max') ) {
				fieldValue++;
				$field.val(fieldValue);
			}
		});
		
		$('.booking-mobile__quantity-down').on('click', function (e) {
			e.preventDefault();
			
			var $field = $(this).next();
			var fieldValue = $field.val();
			
			if ( fieldValue > $field.attr('min') ) {
				fieldValue--;
				$field.val(fieldValue);
			}
		});
		
		var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
		var dayNames   = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
		
		//var datepicker = new Datepickk();
		var today = new Date();
		var tomorrow = new Date();
			tomorrow.setDate(today.getDate() + 1);
		var yesterday = new Date();
			yesterday.setDate(today.getDate() - 1);
		
		var datepicker = new Litepicker({ 
			element: document.getElementById('datepicker'),
			parentEl: $('.booking-mobile__overlay')[0],
			minDate: yesterday,
			numberOfMonths: 2,
			numberOfColumns: 1,
			minDays: 2,
			singleMode: false,
			startDate: today,
			endDate: tomorrow,
			showTooltip: false
		});
		
		datepicker.on('hide', function () {
			updateDatesMobile();
			$('.booking-mobile__overlay').fadeOut();
		});
			
		updateDatesMobile();

		$('.booking-mobile__field--check-in, .booking-mobile__field--check-out').on('click', function () {
			$('.booking-mobile__overlay').fadeIn();
			datepicker.show();
		});
		
		function updateDatesMobile() {
			var checkInDate = new Date( datepicker.getStartDate().dateInstance );
			var checkOutDate = new Date( datepicker.getEndDate().dateInstance );
			
			$('.booking-mobile__field--check-in .booking-mobile__field-date').text( dayNames[ checkInDate.getDay() ] + ' ' + pad(checkInDate.getDate(), 2) + ' ' + monthNames[ checkInDate.getMonth() ] + ' '+ checkInDate.getFullYear() );
			$('input[name="arrive"]').val( pad(checkInDate.getDate(), 2) + '-' +  pad(checkInDate.getMonth()+1*1, 2) + '-' + checkInDate.getFullYear() );
			
			
			$('.booking-mobile__field--check-out .booking-mobile__field-date').text( dayNames[ checkOutDate.getDay() ] + ' ' + pad(checkOutDate.getDate(), 2) + ' ' + monthNames[ checkOutDate.getMonth() ] + ' '+ checkOutDate.getFullYear() );
			$('input[name="depart"]').val( pad(checkOutDate.getDate(), 2) + '-' +  pad(checkOutDate.getMonth()+1*1, 2) + '-' + checkOutDate.getFullYear() );
		}

		// $('.booking-mobile__field-slider-inner').prepend('<div class="booking-mobile__field-slider-slide"></div>'); 
		// $('.booking-mobile__field-slider-inner').append('<div class="booking-mobile__field-slider-slide"></div>');

		$('.booking-mobile__field-slider-inner').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			arrows: false,
			dots: false,
			centerMode: true,
			centerPadding: '65px'
		})

		$('.booking-mobile__field-slider-inner').on('afterChange', function(event, slick, currentSlide) {
			var hotelInput = $('input[name="hotel"]');
			var hotelID = $(slick.$slides[currentSlide]).find('.booking-mobile__field-slider-slide').data('hotel');
			hotelInput.val(hotelID);
		})
	}
}